"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveWarnings = void 0;
const dayjs = require("dayjs");
const getActiveWarnings = (date, warnings) => {
    if (!warnings)
        return [];
    const day = dayjs(date).format("ddd");
    const active_warnings = warnings.filter((warning) => {
        if (dayjs(date).isBefore(dayjs(warning.start_date)))
            return false;
        if (dayjs(date).isAfter(dayjs(warning.end_date)))
            return false;
        if (!warning?.days[day.toLowerCase()])
            return false;
        return true;
    });
    return active_warnings;
};
exports.getActiveWarnings = getActiveWarnings;
